import { render, staticRenderFns } from "./wish.vue?vue&type=template&id=7b1368e4&scoped=true&"
import script from "./wish.vue?vue&type=script&lang=js&"
export * from "./wish.vue?vue&type=script&lang=js&"
import style0 from "./wish.vue?vue&type=style&index=0&id=7b1368e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1368e4",
  null
  
)

export default component.exports